import { useState, useEffect, useRef } from "react";
import { useFirestoreDoc } from "hooks/useFirestoreDoc";
import { getFile } from "hooks/utils";

export const useProfile = userId => {
  const [avatarUrl, setAvatarUrl] = useState(null);
  const where = useRef(q => q.where("userId", "==", userId));
  const profile = useFirestoreDoc("users", where.current);
  useEffect(() => {
    getFile(
      profile && profile.avatarLocation
        ? profile.avatarLocation
        : "/user/default/default.png"
    ).then(setAvatarUrl);
    return () => {
      setAvatarUrl();
    };
  }, [profile]);

  return profile || avatarUrl ? { ...profile, avatarUrl } : undefined;
};
